import type { ProductImageView, ProductOption } from './mapCatalog'

/** Product-level images (shared) + the selected variant’s images only. */
export function resolveVariantGallery(
  allImages: ProductImageView[],
  sharedImageIds: string[],
  selectedVariant: ProductOption | undefined,
): ProductImageView[] {
  const allowed = new Set<string>([
    ...sharedImageIds,
    ...(selectedVariant?.imageIds ?? []),
  ])

  const filtered = allImages.filter((image) => allowed.has(image.id))
  if (filtered.length > 0) return filtered

  // Fallback when a variant has no images and there are no shared product photos.
  if (selectedVariant?.imageIds?.length) {
    return allImages.filter((image) => selectedVariant.imageIds!.includes(image.id))
  }
  return allImages
}

export function pickGalleryImageId(
  gallery: ProductImageView[],
  preferredId: string,
): string {
  if (gallery.some((image) => image.id === preferredId)) return preferredId
  return gallery[0]?.id ?? ''
}
